var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleLeftB = function SvgAngleLeftB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.14 12.276 5.922 5.433a1.054 1.054 0 0 0 1.454 0c.416-.388.416-.97 0-1.358l-5.09-4.851 5.09-4.85c.416-.389.416-.97 0-1.359A.98.98 0 0 0 15.79 5a.98.98 0 0 0-.727.291L9.14 10.724c-.416.485-.416 1.067 0 1.552q0-.145 0 0"
  })));
};
export default SvgAngleLeftB;